import { projectService } from '@/services'
import { headquartersFirst } from './defaultTeamProjects'
import { generateHTML } from '@/core/helper-functions'

export default async (bookId, settings) => {
  await projectService.add({
    bookId: bookId,
    title: 'Mission & vision',
    icon: 'orange-book',
    parentId: null,
    body: headquartersFirst(),
    html: generateHTML(headquartersFirst(), settings, 'Mission & vision')
  })
}
